var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.75H13.35C14.1901 6.75 14.6101 6.75 14.931 6.91349C15.2132 7.0573 15.4427 7.28677 15.5865 7.56901C15.75 7.88988 15.75 8.30992 15.75 9.15V14.25M9.75 14.25V3.15C9.75 2.30992 9.75 1.88988 9.58651 1.56901C9.4427 1.28677 9.21323 1.0573 8.93099 0.91349C8.61012 0.75 8.19008 0.75 7.35 0.75H4.65C3.80992 0.75 3.38988 0.75 3.06901 0.91349C2.78677 1.0573 2.5573 1.28677 2.41349 1.56901C2.25 1.88988 2.25 2.30992 2.25 3.15V14.25M16.5 14.25H1.5M4.875 3.75H7.125M4.875 6.75H7.125M4.875 9.75H7.125",
    stroke: "#35C0FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon-company.7f975f5ad85aa1d2c96bd2cee8ee508e7c5f649d7b9544eaad522d5fdfc219b9.svg";
export { ForwardRef as ReactComponent };